import RestService from "~/core/services/rest.service";
import organizationService from "~/modules/organization/services/organization.service";
import type { FetchUserProfileParameters } from "~/modules/user/models/FetchUserProfileParameters.interface";
import type { UserProfile } from "~/modules/user/models/UserProfile.interface";
import type { UserProfileV2 } from "~/modules/user/models/UserProfileV2.interface";

class UserProfileOrganizationService extends RestService {
  /**
   * Retrieve userProfiles
   */
  getUserProfiles({
    organizationCode,
    searchParams,
  }: FetchUserProfileParameters): Promise<UserProfileV2[]> {
    const params = {
      filter: searchParams,
    };

    return this.$apiV2.get(
      `${organizationService.getOrganizationPath(organizationCode)}/profiles`,
      {
        params,
      },
    );
  }

  /**
   * Get multiple profiles
   * @param codes
   */
  getUserProfilesByCodes(codes: string[]): Promise<UserProfile[]> {
    const data = {
      codes,
    };
    const config = {
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
    };
    return this.$api.post(
      `${organizationService.getOrganizationsPath()}/getUserProfilesByCodes`,
      data,
      config,
    );
  }
}

export default new UserProfileOrganizationService();
